import { reduxActions as UI } from "_constants/ui.constants";


export const toggleTooltip = (payload) => (dispatch) => {
  dispatch({ type: UI.TOGGLE_TOOLTIP, payload });
};
